export const environment = {
  production: true,
  estado: '💪 Staging!',
  url_api: 'https://api.development.gofeels.com/api/v1',
  url_base: 'https://reserva.development.gofeels.com',
};
